export function getAbsoluteUrl() {
  const urlBase = `${window.location.protocol}//${window.location.hostname}:${window.location.port}${window.location.pathname}`;
  const urlWithoutEndingSlashes = urlBase.replace(/\/+$/, "");
  const urlWithFinalSlash = `${urlWithoutEndingSlashes}/`;

  return urlWithFinalSlash;
}
